import React from 'react';
import { AdvancedMarker } from '@vis.gl/react-google-maps';

const InfluencerMapMarkers = ({ influencers, onMarkerClick }) => {
    return (
        <>
            {influencers.map((influencer, idx) => (
                <AdvancedMarker
                    key={influencer.city + idx}
                    position={{ lat: influencer.latitude, lng: influencer.longitude }}
                    clickable
                    onClick={() => onMarkerClick(influencer)}
                    // Render after other markers for stacking
                >
                    <img
                        src={influencer.icon || "/influencer.png"}
                        alt={influencer.city + " influencer"}
                        width={50}
                        height={50}
                        style={{ zIndex: 9999, pointerEvents: 'auto' }}
                    />
                </AdvancedMarker>
            ))}
        </>
    );
};

export default InfluencerMapMarkers; 